'use strict';

angular.module('BusinessUnitsControllers')

    .controller('SearchEmployeeController', ['$scope', 'searchService', function ($scope, searchService) {

        $scope.ctxSelectNewBackup = {};

        /* Search an employee */
        $scope.searchEmployees = function () {
            var searchTerm = $scope.ctxSelectNewBackup.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
                $scope.resultEmployees = [];
                return;
            }

            /* Calling API to retrieve active employee */
            searchService.searchActiveEmployees(searchTerm)
                .then(function (foundEmployees) {
                    $scope.resultEmployees = foundEmployees;
                });
        }
    }]);